import { COUNTRY_VN } from 'util/constants';
export const ProductResourceName = 'Product';
export const MachineLendingResourceName = 'Machine Lending';
export const ProductOrderResourceName = 'Order';
export const PromotionResourceName = 'Promotion';
export const PromotionBenefitResourceName = 'Promotion Benefit';
export const PromotionTriggerResourceName = 'Promotion Trigger';
export const AppSubscriptionResourceName = 'App Subscription Status';
export const PaymentTypeResourceName = 'Payment Type';

export const POS_MALL_CATEGORY_PRINTER_PAPER = 1;
export const POS_MALL_CATEGORY_MACHINE_LENDING = 2;
export const POS_MALL_CATEGORY_SUBSCRIPTION_SUNMI = 3;
export const POS_MALL_CATEGORY_SUBSCRIPTION_IAP = 4;
export const POS_MALL_CATEGORY_DEVICE_PURCHASE = 5;
export const POS_MALL_CATEGORY_SUBSCRIPTION_NON_SUNMI = 7;
export const POS_MALL_CATEGORY_REFURBISHED_DEVICE_PURCHASE = 8;
export const SUBSCRIPTION_SUNMI_BANK = 9;
export const SUBSCRIPTION_NON_SUNMI_BANK = 10;
export const BUY_SUNMI_DEVICE = 11;
export const SUBSCRIPTION_IAP_ANDROID = 12
export const SUBSCRIPTION_IAP_IOS = 13
export const DEVICE_TYPE_SUNMIT1_USED = 14
export const DEVICE_TYPE_SUNMIT2_USED = 15

export const PRODUCT_CATEGORY_NAME = {
  [POS_MALL_CATEGORY_PRINTER_PAPER]: 'Printer Paper',
  [POS_MALL_CATEGORY_MACHINE_LENDING]: 'Machine Lending',
  [POS_MALL_CATEGORY_SUBSCRIPTION_SUNMI]: 'Subscription for Sunmi Shops',
  [POS_MALL_CATEGORY_SUBSCRIPTION_IAP]: 'Subscription IAP',
  [POS_MALL_CATEGORY_DEVICE_PURCHASE]: 'Device Purchase',
  [POS_MALL_CATEGORY_SUBSCRIPTION_NON_SUNMI]: 'Subscription for Non-Sunmi Shops',
  [POS_MALL_CATEGORY_REFURBISHED_DEVICE_PURCHASE]: 'Refurbished Device Purchase',
  [SUBSCRIPTION_SUNMI_BANK]: 'Subscription for Sunmi Shops (bank)',
  [SUBSCRIPTION_NON_SUNMI_BANK]: 'Subscription for Non-Sunmi Shops (bank)',
  [BUY_SUNMI_DEVICE]: process.env.REACT_APP_COUNTRY === COUNTRY_VN ? 'Buy Lending Sunmi' : 'Buy Sunmi Device',
  [SUBSCRIPTION_IAP_ANDROID]: 'Subscription IAP for Android',
  [SUBSCRIPTION_IAP_IOS]: 'Subscription IAP for IOS',
  [DEVICE_TYPE_SUNMIT1_USED]: 'SunmiT1_used',
  [DEVICE_TYPE_SUNMIT2_USED]: 'SunmiT2_used',
};


export const PRODUCT_CATEGORY_CHOICES = [
  { id: POS_MALL_CATEGORY_PRINTER_PAPER, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_PRINTER_PAPER] },
  { id: POS_MALL_CATEGORY_MACHINE_LENDING, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_MACHINE_LENDING] },
  { id: POS_MALL_CATEGORY_SUBSCRIPTION_SUNMI, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_SUBSCRIPTION_SUNMI] },
  { id: SUBSCRIPTION_IAP_IOS, name: PRODUCT_CATEGORY_NAME[SUBSCRIPTION_IAP_IOS] },
  { id: SUBSCRIPTION_IAP_ANDROID, name: PRODUCT_CATEGORY_NAME[SUBSCRIPTION_IAP_ANDROID] },
  { id: POS_MALL_CATEGORY_DEVICE_PURCHASE, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_DEVICE_PURCHASE] },
  { id: POS_MALL_CATEGORY_SUBSCRIPTION_NON_SUNMI, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_SUBSCRIPTION_NON_SUNMI] },
  { id: POS_MALL_CATEGORY_REFURBISHED_DEVICE_PURCHASE, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_REFURBISHED_DEVICE_PURCHASE] },
  { id: BUY_SUNMI_DEVICE, name: PRODUCT_CATEGORY_NAME[BUY_SUNMI_DEVICE] },
  { id: DEVICE_TYPE_SUNMIT1_USED, name: PRODUCT_CATEGORY_NAME[DEVICE_TYPE_SUNMIT1_USED] },
  { id: DEVICE_TYPE_SUNMIT2_USED, name: PRODUCT_CATEGORY_NAME[DEVICE_TYPE_SUNMIT2_USED] },
];

export const PRODUCT_CATEGORY_CHOICES_TH = [
  ...PRODUCT_CATEGORY_CHOICES,
  { id: SUBSCRIPTION_SUNMI_BANK, name: PRODUCT_CATEGORY_NAME[SUBSCRIPTION_SUNMI_BANK] },
  { id: SUBSCRIPTION_NON_SUNMI_BANK, name: PRODUCT_CATEGORY_NAME[SUBSCRIPTION_NON_SUNMI_BANK] },
];

export const SUBSCRIPTION_SUNMI = 2;
export const SUBSCRIPTION_NON_SUNMI = 3;

export const SUBSCRIPTION_CHOISES = [
  { id: SUBSCRIPTION_SUNMI, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_SUBSCRIPTION_SUNMI] },
  { id: SUBSCRIPTION_NON_SUNMI, name: PRODUCT_CATEGORY_NAME[POS_MALL_CATEGORY_SUBSCRIPTION_NON_SUNMI] }
];

const DEVICE_TYPE_IPAD = 1;
const DEVICE_TYPE_SUNMI = 2;

export const MACHINE_LENDING_DEVICE_TYPE = {
  [DEVICE_TYPE_IPAD]: 'iPad',
  [DEVICE_TYPE_SUNMI]: 'Sunmi',
};

export const MACHINE_LENDING_DEVICE_TYPE_CHOICES = [
  { id: '', name: '' },
  { id: DEVICE_TYPE_IPAD, name: MACHINE_LENDING_DEVICE_TYPE[DEVICE_TYPE_IPAD] },
  { id: DEVICE_TYPE_SUNMI, name: MACHINE_LENDING_DEVICE_TYPE[DEVICE_TYPE_SUNMI] },
];

const DEVICE_STATUS_LENDING = 1;
const DEVICE_STATUS_RETURNED = 2;

export const MACHINE_LENDING_DEVICE_STATUS = {
  [DEVICE_STATUS_LENDING]: 'Lending',
  [DEVICE_STATUS_RETURNED]: 'Returned',
};

export const MACHINE_LENDING_DEVICE_STATUS_CHOICES = [
  { id: '', name: '' },
  { id: DEVICE_STATUS_LENDING, name: MACHINE_LENDING_DEVICE_STATUS[DEVICE_STATUS_LENDING] },
  { id: DEVICE_STATUS_RETURNED, name: MACHINE_LENDING_DEVICE_STATUS[DEVICE_STATUS_RETURNED] },
];

export const PAYMENT_TYPE_NA = 0;
export const PAYMENT_TYPE_FREE = 1;
export const PAYMENT_TYPE_CASH = 2;
export const PAYMENT_TYPE_APA = 3;
export const PAYMENT_TYPE_APC = 4;
export const PAYMENT_TYPE_BANK = 5;
export const PAYMENT_TYPE_AIRPAY_CREDIT_CARD = 6;


export const PAYMENT_TYPE = {
  [PAYMENT_TYPE_NA]: 'NA',
  [PAYMENT_TYPE_FREE]: 'Free',
  [PAYMENT_TYPE_CASH]: 'Cash Collection',
  [PAYMENT_TYPE_APA]: 'AirPay',
  [PAYMENT_TYPE_APC]: 'AirPay Counter',
  [PAYMENT_TYPE_BANK]: 'Bank',
  [PAYMENT_TYPE_AIRPAY_CREDIT_CARD]: 'Credit Card',
};

export const PAYMENT_TYPE_CHOICES = [
  { id: '', name: '' },
  { id: PAYMENT_TYPE_FREE, name: PAYMENT_TYPE[PAYMENT_TYPE_FREE] },
  { id: PAYMENT_TYPE_BANK, name: PAYMENT_TYPE[PAYMENT_TYPE_BANK] },
];

export const PAYMENT_STATUS_UNPAID = 1;
export const PAYMENT_STATUS_PAID = 2;
export const PAYMENT_STATUS_FAILED = 3;

export const PAYMENT_STATUS = {
  [PAYMENT_STATUS_UNPAID]: 'Unpaid',
  [PAYMENT_STATUS_PAID]: 'Paid',
  [PAYMENT_STATUS_FAILED]: 'Failed'
};

export const PAYMENT_STATUS_CHOICES = [
  { id: '', name: '' },
  { id: PAYMENT_STATUS_UNPAID, name: PAYMENT_STATUS[PAYMENT_STATUS_UNPAID] },
  { id: PAYMENT_STATUS_PAID, name: PAYMENT_STATUS[PAYMENT_STATUS_PAID] },
  { id: PAYMENT_STATUS_FAILED, name: PAYMENT_STATUS[PAYMENT_STATUS_FAILED] },
];

export const EXTENSION_TYPE_PROMOTION = 'Promotion';
export const EXTENSION_TYPE_FIX = 'Fix Payment Issue';
export const EXTENSION_TYPE_BANK = 'Bank Transfer';

export const EXTENSION_CHOICES = [
  { id: '', name: '' },
  { id: EXTENSION_TYPE_PROMOTION, name: 'Promotion'},
  { id: EXTENSION_TYPE_FIX, name: 'Fix Payment Issue'},
  { id: EXTENSION_TYPE_BANK, name: 'Bank Transfer'},
];

export const QUOTA_TYPE_UNLIMITED = 1;
export const QUOTA_TYPE_LIMITED = 2;

export const QUOTA_TYPE_NAME = {
  [QUOTA_TYPE_UNLIMITED]: 'Unlimited',
  [QUOTA_TYPE_LIMITED]: 'Limited',
};

export const QUOTA_TYPE_CHOICES = [
  { id: QUOTA_TYPE_UNLIMITED, name: 'Unlimited'},
  { id: QUOTA_TYPE_LIMITED, name: 'Limited'},
];



// WEBPACK FOOTER //
// ./src/routes/product/utils.js